import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RefreshCw, CheckCircle, AlertCircle } from 'lucide-react';

const ClearCachePage = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('clearing');
  const [message, setMessage] = useState('جاري مسح الذاكرة المؤقتة...');

  useEffect(() => {
    const clearEverything = async () => {
      try {
        // 1. Clear localStorage
        localStorage.clear();
        console.log('✅ localStorage cleared');

        // 2. Clear sessionStorage
        sessionStorage.clear();
        console.log('✅ sessionStorage cleared');

        // 3. Clear cookies
        document.cookie.split(";").forEach((c) => {
          document.cookie = c
            .replace(/^ +/, "")
            .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });
        console.log('✅ Cookies cleared');

        // 4. Clear cache if available
        if ('caches' in window) {
          const cacheNames = await caches.keys();
          await Promise.all(cacheNames.map(name => caches.delete(name)));
          console.log('✅ Cache API cleared');
        }

        // 5. Unregister service workers
        if ('serviceWorker' in navigator) {
          const registrations = await navigator.serviceWorker.getRegistrations();
          await Promise.all(registrations.map(reg => reg.unregister()));
          console.log('✅ Service Workers unregistered');
        }

        setStatus('success');
        setMessage('تم مسح الذاكرة المؤقتة بنجاح!');

        // Redirect after 2 seconds
        setTimeout(() => {
          window.location.href = '/login?cache_cleared=true';
        }, 2000);

      } catch (error) {
        console.error('Error clearing cache:', error);
        setStatus('error');
        setMessage('حدث خطأ في مسح الذاكرة المؤقتة');
      }
    };

    clearEverything();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-[#1E3A8A] to-gray-900 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
        <div className="mb-6">
          <div className="w-20 h-20 bg-white rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-xl border-4 border-[#C8A870]">
            <img 
              src="https://customer-assets.emergentagent.com/job_5ad4f013-9db1-4f9c-b371-b988a841f7e1/artifacts/nmtmq4a0_%D8%A7%D9%8A%D9%82%D9%88%D9%86%D8%A9%20%D8%A7%D9%84%D8%B9%D8%A7%D8%B1.png"
              alt="Wazin"
              className="w-12 h-12 object-contain"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.parentElement.innerHTML = '<div class="text-[#C8A870] text-2xl font-black">W</div>';
              }}
            />
          </div>
        </div>

        {status === 'clearing' && (
          <div className="flex flex-col items-center">
            <RefreshCw className="w-16 h-16 text-[#1E3A8A] animate-spin mb-4" />
            <h2 className="text-2xl font-black text-gray-800 mb-2">منصة وازن</h2>
            <p className="text-gray-600">{message}</p>
          </div>
        )}

        {status === 'success' && (
          <div className="flex flex-col items-center">
            <CheckCircle className="w-16 h-16 text-green-500 mb-4" />
            <h2 className="text-2xl font-black text-gray-800 mb-2">تم بنجاح!</h2>
            <p className="text-gray-600">{message}</p>
            <p className="text-sm text-gray-500 mt-2">جاري التحويل لصفحة تسجيل الدخول...</p>
          </div>
        )}

        {status === 'error' && (
          <div className="flex flex-col items-center">
            <AlertCircle className="w-16 h-16 text-red-500 mb-4" />
            <h2 className="text-2xl font-black text-gray-800 mb-2">خطأ</h2>
            <p className="text-gray-600">{message}</p>
            <button
              onClick={() => window.location.href = '/login'}
              className="mt-4 px-6 py-2 bg-[#1E3A8A] text-white rounded-lg font-bold hover:bg-[#152d6e] transition-all"
            >
              الذهاب لتسجيل الدخول
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClearCachePage;
